import Alert from './alert';

export default function Point(props) {

  function Data(args) {
    return (
      <div>
        <button className="round" style={{ backgroundColor: args.color, color: args.fontcolor, marginTop: "1px", display: "flex", justifyContent: "space-between" }}>
          <span style={{ whiteSpace: "nowrap", overflow: "hidden" }}>{args.name}</span>
          <span style={{ whiteSpace: "nowrap", textIndent: "0.25em", }}>{args.value == null ? "欠測" : args.value + args.unit}</span>
        </button>
      </div>
    );
  }

  return (
    <div style={{ width: "160px" }}>
      <button style={{ color: "white", backgroundColor: "dimgray", whiteSpace: "nowrap", overflow: "hidden" }}>
        <span>{props.point.name}</span>
      </button>
      <div>
        <Data name="気温" value={props.point.temp.display} unit="℃" color={props.point.temp.color} fontcolor={props.point.temp.fontcolor}/>
        <Data name="湿度" value={props.point.humi.display} unit="%" color={props.point.humi.color} fontcolor={props.point.humi.fontcolor}/>
        <Data name="風速" value={props.point.wind.display} unit="m/s" color={props.point.wind.color} fontcolor={props.point.wind.fontcolor}/>
        <Data name="雨量" value={props.point.rain.display} unit="㎜/h" color={props.point.rain.color} fontcolor={props.point.rain.fontcolor}/>
        <Data name="震度" value={props.point.seis.display} unit="" color={props.point.seis.color} fontcolor={props.point.seis.fontcolor}/>
      </div>
    </div>
  )
};